import { useFormContext } from 'react-hook-form';

import { HookFormText } from 'components/hookForm';

import { AttributeFormFieldValues } from '../../../customAttributeModalForm.types';

const maxLength = 65536;

/** Represents the field for providing a placeholder for custom attribute. */
export const PlaceholderFormField = (): JSX.Element => {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<AttributeFormFieldValues>();

  return (
    <HookFormText
      // TODO: [TEAMS-13693] remove casting after updating to RHF v8
      control={control as never}
      label="Placeholder text"
      name="placeholder"
      disabled={isSubmitting}
      shouldUnregister
      helpIcon={{
        text: 'The text that appears in the custom attribute when it has no value set',
      }}
      rules={{
        maxLength: {
          value: maxLength,
          message: `Must not exceed ${maxLength} characters`,
        },
      }}
      componentProps={{ placeholder: 'ID-12345' }}
    />
  );
};
